import React from 'react';
import { useParams } from 'react-router-dom';
import MeetingHistory from '../components/MeetingHistory';

const MeetingHistoryPage: React.FC = () => {
  const { familyId } = useParams<{ familyId: string }>();

  if (!familyId) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-xl text-red-500">חסר מזהה משפחה</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-center mb-4">היסטוריית פגישות</h1>
        <p className="text-center text-gray-600">מזהה משפחה: {familyId}</p>
      </div>
      <MeetingHistory familyId={familyId} />
    </div>
  );
};

export default MeetingHistoryPage;